/**
 * Maximum allowed file size in bytes (15MB).
 * Files larger than this size will be rejected during validation.
 */
export const MAX_FILE_SIZE = 15 * 1024 * 1024;

/**
 * Mapping of allowed MIME types to their corresponding file extensions.
 * Used for file type validation when uploading files.
 *
 * @remarks
 * Organized by category:
 * - Images: jpg, jpeg, png, gif, webp, svg, bmp, tiff
 * - Audio: mp3, wav, ogg, flac, aac
 * - Video: mp4, webm, avi, mov, mkv
 * - Documents: pdf, doc, docx, xls, xlsx, ppt, pptx
 * - Text files: txt, csv, json, xml, html
 * - Archives: zip, rar, 7z, tar, gz
 */
export const ALLOWED_FILE_TYPES = {
  // Images
  'image/jpeg': '.jpg',
  'image/jpg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/webp': '.webp',
  'image/svg+xml': '.svg',
  'image/bmp': '.bmp',
  'image/tiff': '.tiff',
  // Audio
  'audio/mpeg': '.mp3',
  'audio/wav': '.wav',
  'audio/ogg': '.ogg',
  'audio/flac': '.flac',
  'audio/aac': '.aac',
  // Video
  'video/mp4': '.mp4',
  'video/webm': '.webm',
  'video/x-msvideo': '.avi',
  'video/quicktime': '.mov',
  'video/x-matroska': '.mkv',
  // Documents
  'application/pdf': '.pdf',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    '.docx',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    '.pptx',
  // Text files
  'text/plain': '.txt',
  'text/csv': '.csv',
  'application/json': '.json',
  'application/xml': '.xml',
  'text/html': '.html',
  // Archives
  'application/zip': '.zip',
  'application/x-rar-compressed': '.rar',
  'application/x-7z-compressed': '.7z',
  'application/x-tar': '.tar',
  'application/gzip': '.gz',
} as const;
